import './styles/fonts';
import './styles/theme.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { captureInstallPrompt } from './lib/installPrompt';
import { installLaunchQueue } from './lib/launchQueue';
import { applyPrefsToDocument } from './lib/prefs';
import { installAudioUnlock } from './lib/sound';

// Before React: catch Chromium's install prompt and apply the theme so nothing flashes.
captureInstallPrompt();
applyPrefsToDocument();
installAudioUnlock();
installLaunchQueue();

const root = document.getElementById('root');
if (!root) throw new Error('index.html has no #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
